export const NAME = "paymentMethodsPage" as const;
